import { createInlineScript as i, createNoScript as d, createScript as u } from "./functions.js";
const r = {
  pathOverwriter: {
    name: "myPathOverwriter",
    body: `function myPathOverwriter(options) {
  var path = options.path;
  var uuidV4Regex = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-4[0-9a-fA-F]{3}-[89ABab][0-9a-fA-F]{3}-[0-9a-fA-F]{12}/g;
  if (path && uuidV4Regex.test(path)) {
    return path.replace(uuidV4Regex, "_id");
  }
  return path;
}`
  },
  eventsPlaceholder: {
    body: "window.sa_event=window.sa_event||function(){var a=[].slice.call(arguments);window.sa_event.q?window.sa_event.q.push(a):window.sa_event.q=[a]};"
  }
};
function c(a) {
  return a.split(`
`).join(" ");
}
function v(a, e) {
  const n = { hostname: a };
  e != null && e.overridePathUuid && (n["path-overwriter"] = r.pathOverwriter.name), [
    i(c(r.eventsPlaceholder.body)),
    d("https://queue.simpleanalyticscdn.com/noscript.gif"),
    e != null && e.overridePathUuid ? i(c(r.pathOverwriter.body)) : void 0,
    u("simpleanalytics", "https://scripts.simpleanalyticscdn.com/latest.js", {
      defer: !0,
      data: n,
      onloadFn: e == null ? void 0 : e.onLoad
    })
  ].filter((t) => !!t).forEach((t) => document.body.append(t));
}
function w(a, e) {
  window && window.sa_event && window.sa_event(a, e);
}
export {
  v as addAnalytics,
  w as captureEvent
};
